export default {
  homeMenu: {
    name: '我的授权',
    desc: '协议同意情况'
  }
}
